module.exports = __webpack_public_path__ + "static/media/germany.d60a9cc9.svg";